// extracted by mini-css-extract-plugin
export default {"main-container":"MainPage_main-container__NNLrg","progress-container":"MainPage_progress-container__9U4lA","dashboard-container":"MainPage_dashboard-container__E7tDq"};